import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { HttpClientModule ,HTTP_INTERCEPTORS} from '@angular/common/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
//import {MaterialModule} from './material.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import {IsAuthenticatedGuard} from './is-authenticated.guard';
import { IntegratePspComponent } from './integrate-psp/integrate-psp.component';
import { PaymentModule } from './payment/payment.module'
import { MyHttpInterceptor } from './my-http-interceptor';
import {CommonService} from "./common.service";
import { NavbarComponent } from './navbar/navbar.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import {MaterialModule} from './materialModules';
import { IntegrateCscComponent } from './integrate-csc/integrate-csc.component';
import { ThirdPartyVerifyComponent } from './third-party-verify/third-party-verify.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';

import 'zone.js';
import { IntegrateCscCycleComponentComponent } from './integrate-csc-cycle-component/integrate-csc-cycle-component.component';
import { SearchFilterPipe } from './inspectors/status-track/search-filter.pipe';

// import { UserReceiptComponent } from './admin/user-receipt/user-receipt.component';
// import { ReceiptManageComponent } from './admin/receipt-manage/receipt-manage.component';







@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    IntegratePspComponent,
    NavbarComponent,
    SidenavComponent,
    IntegrateCscComponent,
    SearchFilterPipe,
    ThirdPartyVerifyComponent,
    ForgotPasswordComponent,
    IntegrateCscCycleComponentComponent,
   
  
   
    
    




  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    PaymentModule,
    MaterialModule,
   
  ],
  providers: [IsAuthenticatedGuard,
                {
                  provide: HTTP_INTERCEPTORS,
                  useClass: MyHttpInterceptor,
                  multi: true
              },CommonService,

            ],
  bootstrap: [AppComponent]
})
export class AppModule { }
